/**
 * Setup Users page constants (NXTGEN-7362 C5).
 */

export const RIGHT = 'financialclose_master_user_management';

/** Activity log modulename stored on each user-management log entry. */
export const ACTIVITY_LOG_MODULE_NAME = 'user-management';

export const ITEMS_PER_PAGE = 25;

export const MAIN_TABS = {
  USERS: 'users',
  ROLES: 'roles',
};

/**
 * Edit-form role options. value = stored `role`; role_label is locked to the pair.
 * Dropdown item text (name) matches table badge capitalization (ROLE_DISPLAY_BY_LABEL).
 * Stored values stay lowercase role / role_label pairs.
 */
export const ROLE_OPTIONS = [
  { name: 'Controller', value: 'fbc_admin', role_label: 'controller' },
  { name: 'Manager', value: 'manager', role_label: 'manager' },
  { name: 'General', value: 'general', role_label: 'general' },
];

/** Stored role → role_label (locked pairs). */
export const ROLE_LABEL_BY_ROLE = {
  fbc_admin: 'controller',
  manager: 'manager',
  general: 'general',
};

/** role_label → stored role (locked pairs). */
export const ROLE_BY_ROLE_LABEL = {
  controller: 'fbc_admin',
  manager: 'manager',
  general: 'general',
};

/**
 * role_label → table/filter display (first letter capitalized).
 * Raw `role` (e.g. fbc_admin) is never shown.
 */
export const ROLE_DISPLAY_BY_LABEL = {
  controller: 'Controller',
  manager: 'Manager',
  general: 'General',
};

export const TABLE_HEADERS = [
  {
    value: 'name',
    text: 'Name',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'email',
    text: 'Email',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'roleDisplay',
    text: 'Role',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'locationDisplay',
    text: 'Location',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'statusDisplay',
    text: 'Status',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'action',
    text: 'Action',
    sortable: false,
    datatype: 'action',
    lock: true,
    visible: true,
    alignment: 'text-center',
  },
];

export const PAGE_DETAILS = {
  pagename: 'user-management',
  cycle_id: 'global',
};

export const API = {
  LIST: '/v2/financialclose/masters/usermanagement/list',
  GET: (id) => `/v2/financialclose/masters/usermanagement/get/${id}`,
  ADD: '/v2/financialclose/masters/usermanagement/add',
  EDIT: (id) => `/v2/financialclose/masters/usermanagement/edit/${id}`,
  SET_STATUS: (id) => `/v2/financialclose/masters/usermanagement/setstatus/${id}`,
  /**
   * Full location master (enabled + disabled). Same endpoint as Setup Location
   * (`setup` LOCATION_GET / `setup/fetchLocations`).
   */
  LOCATIONS_GET: '/v2/financialclose/location/get',
  ENTITY_USERS: '/v2/client/getAllUsersForEntity',
};

export const ROLES_TAB_PLACEHOLDER =
  'Roles management will be available in a later release.';

/** Add user is intentionally disabled on the UI (API still exists). */
export const ADD_USER_ENABLED = false;
